export const ExternalChatResponseType = {
  FrmAccountSearch: 'frm-account-search',
  RepTerritoryInsights: 'rep-territory-insights',
  DMTerritoryInsights: 'dm-territory-insights',
  RepTwoMinuteSummary: 'rep-two-minute-summary',
  DMHCPAlerts: 'dm-hcp-alerts',
} as const;

export type ExternalChatResponseType =
  (typeof ExternalChatResponseType)[keyof typeof ExternalChatResponseType];

/**
 * All external response type values that are eligible as initial-message config types.
 * Used by management-app-client to generate config schemas and by chat-api for generic handling.
 */
export const EXTERNAL_INITIAL_MESSAGE_CONFIG_TYPES: ExternalChatResponseType[] =
  Object.values(ExternalChatResponseType);

/**
 * Display labels for external response types used by admin-facing config UIs.
 */
export const EXTERNAL_CHAT_RESPONSE_TYPE_LABELS: Record<ExternalChatResponseType, string> = {
  [ExternalChatResponseType.FrmAccountSearch]: 'FRM Account Search',
  [ExternalChatResponseType.RepTerritoryInsights]: 'Rep Territory Insights',
  [ExternalChatResponseType.DMTerritoryInsights]: 'DM Territory Insights',
  [ExternalChatResponseType.RepTwoMinuteSummary]: 'Rep Two Minute Summary',
  [ExternalChatResponseType.DMHCPAlerts]: 'DM HCP Alerts',
};

export type ExternalChatQueryResponseMap = {
  [ExternalChatResponseType.FrmAccountSearch]: {
    type: typeof ExternalChatResponseType.FrmAccountSearch;
    value: string;
    data: Record<string, unknown>;
  };
  [ExternalChatResponseType.RepTerritoryInsights]: {
    type: typeof ExternalChatResponseType.RepTerritoryInsights;
    value: string;
    data: Record<string, unknown>;
  };
  [ExternalChatResponseType.DMTerritoryInsights]: {
    type: typeof ExternalChatResponseType.DMTerritoryInsights;
    value: string;
    data: Record<string, unknown>;
  };
  [ExternalChatResponseType.RepTwoMinuteSummary]: {
    type: typeof ExternalChatResponseType.RepTwoMinuteSummary;
    value: string;
    data: {
      repId: string;
    };
  };
  [ExternalChatResponseType.DMHCPAlerts]: {
    type: typeof ExternalChatResponseType.DMHCPAlerts;
    value: string;
    data: {
      hcpId: string;
    };
  };
};

export type ExternalChatQueryResponse<T extends ExternalChatResponseType = ExternalChatResponseType> =
  ExternalChatQueryResponseMap[T];

export type ExternalChatQueryState<_T extends ExternalChatResponseType = ExternalChatResponseType> = Record<
  string,
  unknown
>;

export type CustomResponseInput = ExternalChatQueryResponse;

export type CustomResponseSerializerInput = {
  response: CustomResponseInput;
  state: ExternalChatQueryState;
};

export type CustomResponseDocxCategory = 'direct-value' | 'markdown' | 'static' | 'custom';
